import { defineMessages } from "react-intl";

const messages = defineMessages({
  hotelsIn: {
    id: "hotelPromo.hotelsIn",
    defaultMessage: "Hotels in {location}",
    description:
      "A header for a hotel promo that takes user to the Rome2Rio hotel experience.",
  },
  hotelsNear: {
    id: "hotelPromo.hotelsNear",
    defaultMessage: "Hotels near {location}",
    description:
      "A header for a hotel promo that takes user to the Rome2Rio hotel experience.",
  },
  eightPlus: {
    id: "hotelPromo.eightPlus",
    defaultMessage: "8+ rating hotels",
    description:
      "A label for a hotel promo that will show users hotels with a rating of 8 or higher.",
  },
  sevenPlus: {
    id: "hotelPromo.sevenPlus",
    defaultMessage: "7+ rating hotels",
    description:
      "A label for a hotel promo that will show users hotels with a rating between 7 and 8.",
  },
  rental: {
    id: "hotelPromo.rental",
    defaultMessage: "Rentals",
    description:
      "A label for a hotel promo that will show users rental properties.",
  },
  viewMore: {
    id: "hotelPromo.viewMore",
    defaultMessage: "View more",
    description: "Label for view more button in hotel promo.",
  },
});

export default messages;
